import {
  OFFSHORE_EVENT_TYPES,
  OffshoreEventTypes,
  OffshoreFormConfig,
} from '@navstation-portal/reporting/data-model/offshore-report';

export const mockVesselSpecForm: OffshoreFormConfig = {
  tabs: {
    operational: {
      sections: {
        reportDetails: {
          label: 'Report Details',
          visible: true,
          visible_types: OffshoreEventTypes,
          fields: {
            reportNumber: {
              label: 'Report Number',
              readonly_types: OffshoreEventTypes,
              required_types: [],
              visible_types: OffshoreEventTypes,
            },
            reportCreation: {
              label: 'Report Creation',
              readonly_types: OffshoreEventTypes,
              required_types: [],
              visible_types: OffshoreEventTypes,
            },
            reportFrom: {
              label: 'Report From',
              readonly_types: [],
              required_types: OffshoreEventTypes,
              visible_types: OffshoreEventTypes,
            },
            reportTo: {
              readonly_types: [],
              required_types: OffshoreEventTypes,
              visible_types: OffshoreEventTypes,
            },
            reportPeriod: {
              readonly_types: [
                OFFSHORE_EVENT_TYPES.PORT,
                OFFSHORE_EVENT_TYPES.ANCHOR,
                OFFSHORE_EVENT_TYPES.DRIFTING,
                OFFSHORE_EVENT_TYPES.DYNAMIC_POSITIONING,
                OFFSHORE_EVENT_TYPES.STANDBY_ON_LOCATION,
                OFFSHORE_EVENT_TYPES.DRY_DOCK_REPAIR,
              ],
              required_types: OffshoreEventTypes,
              visible_types: OffshoreEventTypes,
            },

            timeSailed: {
              readonly_types: [],
              required_types: [
                OFFSHORE_EVENT_TYPES.SEA,
                OFFSHORE_EVENT_TYPES.ARRIVAL,
                OFFSHORE_EVENT_TYPES.MANEUVERING,
                OFFSHORE_EVENT_TYPES.CANAL_TRANSIT,
                OFFSHORE_EVENT_TYPES.DEPARTURE,
              ],
              visible_types: OffshoreEventTypes,
            },

            timezone: {
              readonly_types: [],
              required_types: OffshoreEventTypes,
              visible_types: OffshoreEventTypes,
            },
            previousTimezone: {
              readonly_types: [],
              required_types: OffshoreEventTypes,
              visible_types: OffshoreEventTypes,
            },

            reportSubmitted: {
              readonly_types: OffshoreEventTypes,
              required_types: [],
              visible_types: OffshoreEventTypes,
            },
          },
        },

        voyageDetails: {
          label: 'Voyage Details',
          visible: true,
          visible_types: OffshoreEventTypes,
          fields: {
            voyageNumber: {
              readonly_types: [],
              required_types: OffshoreEventTypes,
              visible_types: OffshoreEventTypes,
            },
            voyageFrom: {
              readonly_types: [],
              required_types: OffshoreEventTypes,
              visible_types: OffshoreEventTypes,
            },
            voyageTo: {
              readonly_types: [],
              required_types: OffshoreEventTypes,
              visible_types: OffshoreEventTypes,
            },
            eta: {
              readonly_types: [],
              required_types: [OFFSHORE_EVENT_TYPES.SEA, OFFSHORE_EVENT_TYPES.ARRIVAL, OFFSHORE_EVENT_TYPES.DEPARTURE],
              visible_types: OffshoreEventTypes,
            },
            etaTimezone: {
              readonly_types: [],
              required_types: [OFFSHORE_EVENT_TYPES.SEA, OFFSHORE_EVENT_TYPES.ARRIVAL, OFFSHORE_EVENT_TYPES.DEPARTURE],
              visible_types: OffshoreEventTypes,
            },
          },
        },
        crewAndPassengers: {
          label: 'Crew and Passengers',
          visible: true,
          visible_types: OffshoreEventTypes,
          fields: {
            numCrew: {
              label: 'Number of Crew',
              readonly_types: [],
              required_types: OffshoreEventTypes,
              visible_types: OffshoreEventTypes,
            },
            numMarineCrew: {
              label: 'Number of Marine Crew',
              readonly_types: [],
              required_types: [],
              visible_types: [OFFSHORE_EVENT_TYPES.SEA, OFFSHORE_EVENT_TYPES.ARRIVAL],
            },
            numContractors: {
              label: 'Number of Contractors',
              readonly_types: [],
              required_types: [],
              visible_types: [OFFSHORE_EVENT_TYPES.SEA, OFFSHORE_EVENT_TYPES.ARRIVAL],
            },
            numClients: {
              label: 'Number of Clients',
              readonly_types: [],
              required_types: [],
              visible_types: [OFFSHORE_EVENT_TYPES.SEA, OFFSHORE_EVENT_TYPES.ARRIVAL],
            },
            numPassengers: {
              label: 'Number of Passengers',
              readonly_types: [],
              required_types: [],
              visible_types: [OFFSHORE_EVENT_TYPES.SEA, OFFSHORE_EVENT_TYPES.ARRIVAL],
            },
          },
        },
        miscellaneous: {
          label: 'Miscellaneous',
          visible: true,
          visible_types: OffshoreEventTypes,
          fields: {
            captainName: {
              readonly_types: [],
              required_types: OffshoreEventTypes,
              visible_types: [],
            },
            chiefEngineer: {
              readonly_types: [],
              required_types: OffshoreEventTypes,
              visible_types: [],
            },
            cargoWeight: {
              readonly_types: [],
              required_types: OffshoreEventTypes,
              visible_types: OffshoreEventTypes,
            },
            clientChartererName: {
              readonly_types: [],
              required_types: [OFFSHORE_EVENT_TYPES.SEA, OFFSHORE_EVENT_TYPES.ARRIVAL],
              visible_types: [OFFSHORE_EVENT_TYPES.SEA, OFFSHORE_EVENT_TYPES.ARRIVAL],
            },
            supportVessels: {
              readonly_types: [],
              required_types: [OFFSHORE_EVENT_TYPES.SEA, OFFSHORE_EVENT_TYPES.ARRIVAL],
              visible_types: [OFFSHORE_EVENT_TYPES.SEA, OFFSHORE_EVENT_TYPES.ARRIVAL],
            },
            activityLog: {
              readonly_types: [],
              required_types: [OFFSHORE_EVENT_TYPES.SEA, OFFSHORE_EVENT_TYPES.ARRIVAL],
              visible_types: [OFFSHORE_EVENT_TYPES.SEA, OFFSHORE_EVENT_TYPES.ARRIVAL],
            },
          },
        },
      },
    },
    positionAndWeather: {
      sections: {
        positionAndLogistics: {
          label: 'Position and Logistics',
          visible: true,
          visible_types: OffshoreEventTypes,
          fields: {
            position: {
              readonly_types: [],
              required_types: OffshoreEventTypes,
              visible_types: OffshoreEventTypes,
            },
            logDistance: {
              readonly_types: [],
              required_types: [
                OFFSHORE_EVENT_TYPES.SEA,
                OFFSHORE_EVENT_TYPES.ARRIVAL,
                OFFSHORE_EVENT_TYPES.MANEUVERING,
                OFFSHORE_EVENT_TYPES.DRIFTING,
                OFFSHORE_EVENT_TYPES.CANAL_TRANSIT,
                OFFSHORE_EVENT_TYPES.DEPARTURE,
              ],
              visible_types: OffshoreEventTypes,
            },
            observedDistance: {
              readonly_types: [],
              required_types: [
                OFFSHORE_EVENT_TYPES.SEA,
                OFFSHORE_EVENT_TYPES.ARRIVAL,
                OFFSHORE_EVENT_TYPES.MANEUVERING,
                OFFSHORE_EVENT_TYPES.DRIFTING,
                OFFSHORE_EVENT_TYPES.CANAL_TRANSIT,
                OFFSHORE_EVENT_TYPES.DEPARTURE,
              ],
              visible_types: OffshoreEventTypes,
            },
            logSpeed: {
              readonly_types: [],
              required_types: [OFFSHORE_EVENT_TYPES.SEA, OFFSHORE_EVENT_TYPES.ARRIVAL],
              visible_types: [OFFSHORE_EVENT_TYPES.SEA, OFFSHORE_EVENT_TYPES.ARRIVAL],
            },
            observedSpeed: {
              readonly_types: [],
              required_types: [OFFSHORE_EVENT_TYPES.SEA, OFFSHORE_EVENT_TYPES.ARRIVAL],
              visible_types: [OFFSHORE_EVENT_TYPES.SEA, OFFSHORE_EVENT_TYPES.ARRIVAL],
            },
            courseOverGround: {
              readonly_types: [],
              required_types: [],
              visible_types: [OFFSHORE_EVENT_TYPES.SEA, OFFSHORE_EVENT_TYPES.ARRIVAL],
            },
          },
        },
        weatherDetails: {
          label: 'Weather Details',
          visible: true,
          visible_types: [OFFSHORE_EVENT_TYPES.SEA, OFFSHORE_EVENT_TYPES.ARRIVAL],
          fields: {
            apparentWindSpeed: {
              readonly_types: [],
              required_types: [],
              visible_types: [OFFSHORE_EVENT_TYPES.SEA, OFFSHORE_EVENT_TYPES.ARRIVAL],
            },
            apparentWindDirection: {
              readonly_types: [],
              required_types: [],
              visible_types: [OFFSHORE_EVENT_TYPES.SEA, OFFSHORE_EVENT_TYPES.ARRIVAL],
            },
          },
        },
      },
    },
    consumptions: {
      sections: {
        fuelSpecs: {
          label: 'Fuel Specifications',
          visible: true,
          visible_types: OffshoreEventTypes,
          fields: {
            fuelSpecs: {
              readonly_types: [],
              required_types: OffshoreEventTypes,
              visible_types: OffshoreEventTypes,
            },
          },
        },
        totalConsumptions: {
          label: 'Total Consumptions',
          visible: true,
          visible_types: OffshoreEventTypes,
          fields: {
            totalConsumptions: {
              readonly_types: [],
              required_types: OffshoreEventTypes,
              visible_types: OffshoreEventTypes,
            },
          },
        },
      },
    },
    bunker: {
      sections: {
        fuelOilBunkerTable: {
          label: 'Bunkering',
          visible: true,
          visible_types: [
            OFFSHORE_EVENT_TYPES.PORT,
            OFFSHORE_EVENT_TYPES.ANCHOR,
            OFFSHORE_EVENT_TYPES.DRIFTING,
            OFFSHORE_EVENT_TYPES.DYNAMIC_POSITIONING,
            OFFSHORE_EVENT_TYPES.STANDBY_ON_LOCATION,
            OFFSHORE_EVENT_TYPES.DRY_DOCK_REPAIR,
          ],
          fields: {
            bunkerTable: {
              label: 'Bunkering Table',
              readonly_types: [],
              required_types: [
                OFFSHORE_EVENT_TYPES.PORT,
                OFFSHORE_EVENT_TYPES.ANCHOR,
                OFFSHORE_EVENT_TYPES.DRIFTING,
                OFFSHORE_EVENT_TYPES.DYNAMIC_POSITIONING,
                OFFSHORE_EVENT_TYPES.STANDBY_ON_LOCATION,
                OFFSHORE_EVENT_TYPES.DRY_DOCK_REPAIR,
              ],
              visible_types: [
                OFFSHORE_EVENT_TYPES.PORT,
                OFFSHORE_EVENT_TYPES.ANCHOR,
                OFFSHORE_EVENT_TYPES.DRIFTING,
                OFFSHORE_EVENT_TYPES.DYNAMIC_POSITIONING,
                OFFSHORE_EVENT_TYPES.STANDBY_ON_LOCATION,
                OFFSHORE_EVENT_TYPES.DRY_DOCK_REPAIR,
              ],
            },
          },
        },
      },
    },
    stock: {
      sections: {
        tankStockTable: {
          label: 'Tank Stock',
          visible: true,
          visible_types: OffshoreEventTypes,
          fields: {
            inUseTanks: {
              label: 'In Use',
              readonly_types: [],
              required_types: OffshoreEventTypes,
              visible_types: OffshoreEventTypes,
            },
            notInUseTanks: {
              label: 'Not In Use',
              readonly_types: [],
              required_types: OffshoreEventTypes,
              visible_types: OffshoreEventTypes,
            },
          },
        },

        tanks: {
          label: 'Tanks',
          visible: true,
          visible_types: OffshoreEventTypes,
          fields: {
            tankTransfers: {
              label: 'Transfers',
              readonly_types: [],
              required_types: OffshoreEventTypes,
              visible_types: OffshoreEventTypes,
            },
          },
        },
        rob: {
          label: 'ROB',
          visible: true,
          visible_types: OffshoreEventTypes,
          fields: {
            fuelROB: {
              label: 'Fuel ROB',
              readonly_types: [],
              required_types: OffshoreEventTypes,
              visible_types: OffshoreEventTypes,
            },
          },
        },
      },
    },
  },
};
